import { Component } from '@angular/core';
import { Router, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { filter } from 'rxjs/operators';
import * as AOS from "aos";
import { PathsDataService } from './services/paths-data.service';
import { ImgsCollection } from './interfaces/images/imgs-collection.interface';
import { footerKey } from './interfaces/images/nav-footer-collection.interface';
import { ImagesService } from './services/images.service';
import { ApiResponse, ImagesData } from './interfaces/images/image.data.interface';
import { IconsCollection } from './interfaces/icons/icons-collection.interface';
import { MatDialog } from '@angular/material/dialog';
import { ModalCompleteUserDataComponent } from './components/common/modal-complete-user-data/modal-complete-user-data.component';
import { ModalService } from './components/common/modal-complete-user-data/modal-service/modal.service';
import { SecurityHeadersService } from './services/security-headers.service';
import { env } from 'src/environments/environments';
import { homeImgsKeys } from './components/pages/home/h-interfaces/img-h-keys/home-img-key.interface';
declare let $: any;



const DEFAULT_IMAGES: Record<string, string> =  env.DEFAULT_IMAGES;


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent {

    title = 'Clarity - PQRSF | AI SYSTEM';

    location: any;
    routerSubscription: any;
    imagesHome: Record<string, string> = {};
    logoGov?: string;
    footerImgs?: footerKey;
    dataLoaded: boolean = false;
    

    imgsData?: ApiResponse;


    constructor(
        public router: Router,
        private pathsDataService: PathsDataService,
        private imagesService: ImagesService,
        private dialog: MatDialog,
        private modalService: ModalService,
        private securityHeadersService: SecurityHeadersService
    ) {
        AOS.init();
    }

    async ngOnInit(){
        this.getDomain();
        this.recallJsFuntions();
        this.resquestPathIcns();
        this.getImagesAssets();
    }

    recallJsFuntions() {
        this.routerSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
        .subscribe(event => {
            this.location = this.router.url;
            if (!(event instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }



    defaultPathImg() {
        this.imagesHome = { ...DEFAULT_IMAGES };
        this.logoGov = this.imagesHome['logo'];
    }

    checkDataLoaded() {
        if (this.logoGov) {
            this.dataLoaded = true;
        }
    }

    getDomain() {
        // Obtener el dominio actual
        let fullDomain = `${window.location.protocol}//${window.location.hostname}`;

        if(fullDomain === 'http://localhost') {
            fullDomain = `${fullDomain}:${window.location.port}`;
        }

        sessionStorage.setItem('domain', fullDomain);
    }


    resquestPathImgs() {
        this.pathsDataService.getPathImgs()
        .subscribe({
            next: (data: ImgsCollection) => {
                this.logoGov = data.navbar.logo;
                this.checkDataLoaded();
            },
            error: (error) => {
                console.error(error);
            }
        });
    }
    
    resquestPathIcns() {
        this.pathsDataService.getPathIcons()
        .subscribe({
            next: (data: IconsCollection) => {
                this.footerImgs = data.footer;
            },
            error: (error) => {
                console.error(error);
            }
        });
    }


    getImagesAssets(): void {
        this.imagesService.getImages().subscribe({
            next: (response) => {
                if (response.success) {
                    this.logoGov = response.data?.find(item => item.seccion === 'logo landing')?.ruta;
                } else {
                    console.error('Error en el consumo del servicio: ', response.message);
                    //this.defaultPathImg();
                    this.resquestPathImgs();
                }
            },
            error: (error) => {
                console.error('Error en el servicio: ', error);
                this.defaultPathImg();
            }
        });
    }

}
